if (!customElements.get("delivery-date")) {
  customElements.define(
    "delivery-date",
    class DeliveryDate extends window.Component {
      constructor() {
        super();
        const appendElement = this.querySelector("#delivery strong");
        appendElement.innerHTML = this.getDeliveryDate();
      }

      getDateAfterBusinessDays(days, language) {
        const daysOfWeek =
          language == "ko"
            ? [
                "일",
                "월",
                "화",
                "수",
                "목",
                "금",
                "토",
              ]
            : [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
              ];
        const months =
          language == "ko"
            ? [
                "일월",
                "이월",
                "삼월",
                "사월",
                "오월",
                "유월",
                "칠월",
                "팔월",
                "구월",
                "시월",
                "십일월",
                "십이월월",
              ]
            : [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ];
        const currentDate = new Date();
        const targetDate = new Date(currentDate);
        let businessDaysAdded = 0;

        while (businessDaysAdded < days) {
          targetDate.setDate(targetDate.getDate() + 1);
          const dayOfWeek = targetDate.getDay();
          // Skip Saturday (6) and Sunday (0)
          if (dayOfWeek !== 0 && dayOfWeek !== 6) {
              businessDaysAdded++;
          }
        }

        const month = (targetDate.getMonth() + 1).toString().padStart(2, '0');
        const day = targetDate.getDate().toString().padStart(2, '0');
        const text =
          language == "ko"
            ? `${month}월 ${day}일(${daysOfWeek[targetDate.getDay()]})`
            : `${daysOfWeek[targetDate.getDay()]}, ${months[targetDate.getMonth()]} ${day}`;
        return text;
      }

      getDeliveryDate() {
        const language = this.getState("language");
        const deliveryDate = this.getState("deliveryDate");
        const shippingDays = deliveryDate.trim();
        const days = (
          shippingDays && shippingDays.includes("-")
            ? shippingDays
            : "3-5"
        )
          .split("-")
          .map((day) => parseInt(day.trim(), 10));
        const [minDay, maxDay] = days;

        return `${this.getDateAfterBusinessDays(minDay, language)} ${
            "-"
        } ${this.getDateAfterBusinessDays(maxDay, language)}`;
      }
    }
  );
}